export const createFlagImage = (): {
  width: number;
  height: number;
  data: Uint8ClampedArray;
} | null => {
  if (typeof document === "undefined") return null;
  const size = 32;
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;
  // Pole
  ctx.lineCap = "round";
  ctx.strokeStyle = "rgba(60, 60, 60, 0.95)";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(6, 30);
  ctx.lineTo(6, 4);
  ctx.stroke();
  // Flag triangle
  ctx.fillStyle = "rgba(220, 38, 38, 0.7)";
  ctx.beginPath();
  ctx.moveTo(6, 4);
  ctx.lineTo(24, 10);
  ctx.lineTo(6, 16);
  ctx.closePath();
  ctx.fill();
  ctx.strokeStyle = "rgba(0, 0, 0, 0.35)";
  ctx.lineWidth = 1;
  ctx.stroke();
  const img = ctx.getImageData(0, 0, size, size);
  return { width: size, height: size, data: img.data };
};
